import type { CreditNote } from '~/api/creditNotes/types';

import { useUser } from '~/api/user';
import { BrandDot } from '~/components';
import { desktopTruncateStyle } from '~/styles/utilities.css';
import { clsx } from '~/styles/utils';

import { titleCellStyle, titleStyle, titleWrapperStyle } from './creditNoteCell.css';

type Props = {
  creditNote: CreditNote;
};

export const CreditNoteTitleCell = ({ creditNote }: Props) => {
  const { data: user } = useUser();

  const brand = user.brands.find(({ id }) => id === creditNote.brandId);

  return (
    <div className={titleCellStyle}>
      <div className={clsx(desktopTruncateStyle, titleWrapperStyle)}>
        <div className={clsx(titleStyle, desktopTruncateStyle)}>
          {brand && brand.color && <BrandDot color={brand.color} small />}

          <span className={desktopTruncateStyle}>{creditNote.description}</span>
        </div>

        <div className={desktopTruncateStyle}>
          <span>{creditNote.fcEntryNumber}</span>
        </div>
      </div>
    </div>
  );
};
